<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="单词课程" name="first">
                <el-table
                        :data="tabList"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="curriculum_name"
                            align="center"
                            label="课本名称">
                    </el-table-column>
                    <el-table-column
                            prop="difficult_level"
                            align="center"
                            label="难度">
                    </el-table-column>
                    <el-table-column
                            prop="unit_num"
                            align="center"
                            width="180"
                            label="单元总数">
                    </el-table-column>
                    <el-table-column
                            prop="state"
                            align="center"
                            width="180"
                            label="是否过期">
                    </el-table-column>
                    <el-table-column
                            prop="over_time"
                            align="center"
                            width="180"
                            label="到期时间">
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="语法课程" name="second">
                <el-table
                        :data="tabList"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="curriculum_name"
                            align="center"
                            label="课本名称">
                    </el-table-column>
                    <el-table-column
                            prop="difficult_level"
                            align="center"
                            label="难度">
                    </el-table-column>
                    <el-table-column
                            prop="unit_num"
                            align="center"
                            width="180"
                            label="单元总数">
                    </el-table-column>
                    <el-table-column
                            prop="state"
                            align="center"
                            width="180"
                            label="是否过期">
                    </el-table-column>
                    <el-table-column
                            prop="over_time"
                            align="center"
                            width="180"
                            label="到期时间">
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="音标课程" name="three">
                <el-table
                        :data="tabList"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="curriculum_name"
                            align="center"
                            label="课本名称">
                    </el-table-column>
                    <el-table-column
                            prop="difficult_level"
                            align="center"
                            label="难度">
                    </el-table-column>
                    <el-table-column
                            prop="unit_num"
                            align="center"
                            width="180"
                            label="单元总数">
                    </el-table-column>
                    <el-table-column
                            prop="state"
                            align="center"
                            width="180"
                            label="是否过期">
                    </el-table-column>
                    <el-table-column
                            prop="over_time"
                            align="center"
                            width="180"
                            label="到期时间">
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {subscribeToCourse} from "@/api/parent";

    export default {
        name: "starCourse",
        data() {
            return {
                activeName: 'first',
                tabType: '1',//课程类型
                tabList: [],//课程列表

            };
        },
        methods: {
            handleClick(tab, event) {
                if (tab.paneName == "first") {
                    this.getStarCourse(1)
                }
                if (tab.paneName == "second") {
                    this.getStarCourse(2)
                } else {
                    this.getStarCourse(3)
                }
            },
            getStarCourse(type = 1) {
                let params = {
                    token: Lockr.get('parentToken'),
                    student_id: this.$route.query.student_id,
                    type: type,
                }
                subscribeToCourse(params).then(result => {
                    if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                        this.tabList = result.data.data
                        this.tabList.map(item => {
                            item.state == 0 ? item.state = '已过期' : item.state == 1 ? item.state = '试用' : item.state == 2 ? item.state = '已购买' : ''
                        })
                    } else {
                        this.$alert(result.msg, '温馨提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                            }
                        });
                    }
                })
            }
        },
        created() {
            this.getStarCourse()
        },
        beforeCreate() {
            document.querySelector("body").setAttribute("style", "background-color:#fff");
        }
    }
</script>

<style scoped lang='less'>

</style>